import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { StationProcessingSession } from "./station-processing-session";

export const openStationProcessingSession = {
  name: "openStationProcessingSession" as const,
  input: z.object({
    workstationId: z.string(),
    locationId: locationIdFormat.schema,
  }),
  output: z.object({ session: StationProcessingSession }),
};
